"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getFromFirebaseReference_1 = require("../shared/getFromFirebaseReference");
const getAppMembersReference = (database) => (projectId) => (appId) => {
    const mainPath = `projects/${projectId}/apps/${appId}/members`;
    const membersRef = database.ref(mainPath);
    const get = () => (0, getFromFirebaseReference_1.getFromFirebaseReference)(membersRef);
    const subscribe = (0, getFromFirebaseReference_1.getListenerFromFirebaseReference)(membersRef);
    const removeMember = (memberId) => membersRef.child(memberId).remove();
    return {
        get,
        subscribe,
        removeMember,
    };
};
exports.default = getAppMembersReference;
